import { createContext, useContext, useState } from "react";

export const CartContext = createContext([]);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  const localHousing = () => localStorage.setItem("cart", JSON.stringify(cart));

  const addToCart = (item) => {
    setCart([...cart, item]);
    localHousing();
  };

  const removeFromCart = (item) => {
    const removeProduct = cart.findIndex((product) => product.name === item.name);
    const updateCart = cart.filter((product, index) => index !== removeProduct)
    setCart(updateCart);
    localHousing();
  };

  return (
    <CartContext.Provider value={{ cart, setCart, addToCart, removeFromCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
